<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>{{ $t('passwords.password_forgot_title') }}</h1>
                <p class="text-muted" v-if="!emailSent">
                  {{ $t('passwords.password_forgot_description') }}
                </p>
                <p class="text-success" v-if="emailSent">{{ $t('passwords.sent') }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="email" type="text" class="form-control"
                                :placeholder=" $t('global.email') "
                                :class="{ 'is-invalid' : errorMsg.email }"
                                v-model="email"/>
                  <div class="invalid-feedback" v-if="errorMsg.email">{{ errorMsg.email[0] }}</div>
                </b-input-group>

                <b-button variant="success" block @click="onSend()" :disabled="emailSent">
                  <b-spinner v-if="sendSpinner" small/> {{ $t('global.send') }} </b-button>
                <b-row>
                  <b-col cols="12" class="text-center">
                    <b-button variant="link" class="px-0" :to="{ name: 'Login' }">
                      {{ $t('auth.return_to_login') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {
    this.$refs.email.$el.focus();
  },
  data() {
    return {
      email: '',
      emailSent: false,
      errorMsg: {},
      sendSpinner: false
    };
  },
  computed: {
    ...mapGetters('Auth', [
      'forgotPassword',
    ]),
  },
  watch: {
    forgotPassword: 'onForgotPasswordResponse',
  },
  methods: {
    ...mapActions('Auth', [
      VT.FORGOT_PASSWORD,
    ]),
    onSend() {
      this.sendSpinner = true;
      this.FORGOT_PASSWORD({
        email: this.email
      });
    },
    onForgotPasswordResponse() {
      this.sendSpinner = false;
      this.errorMsg = {};
      if (this.forgotPassword.status === statuses.LOADED) {
        this.emailSent = true;
      } else if (this.forgotPassword.status === statuses.ERROR) {
        this.errorMsg = this.forgotPassword.data.data.errors;
      }
    },
  }
};

</script>
